import { render, staticRenderFns } from "./OlvidePobox.vue?vue&type=template&id=18ccaae8&"
import script from "./OlvidePobox.vue?vue&type=script&lang=js&"
export * from "./OlvidePobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports